/* eslint-disable no-undef */
import i18n from 'i18next';
import Backend from './backend';
import { setMomentLocale } from './momentLocale';
import {
    getAssessmentCompanyDomain,
    lookupTranslationOverride,
    translationLookupKeys,
} from './translationOverrideLookup';

let instance;

function init(commonStore) {
    i18n.use({
        type: 'postProcessor',
        name: 'companyOverrides',
        process: function (value, key) {
            try {
                const brandingStore = window.__stores.brandingStore || {};
                const assessmentStore = window.__stores.assessmentStore || {};
                const questionStore = window.__stores.questionStore || {};

                const lng = i18n.language;
                const companyDomain = getAssessmentCompanyDomain(
                    assessmentStore,
                    questionStore
                );
                const lookupKeys = translationLookupKeys(key, companyDomain);

                const override = lookupTranslationOverride(lookupKeys, lng, {
                    questionTranslations:
                        questionStore?.question?.translations,
                    assessmentTranslations:
                        assessmentStore?.assessment?.definition
                            ?.translations,
                    branding: brandingStore?.branding,
                });

                if (override != null) {
                    return override;
                }

                if (!brandingStore?.brandingLoaded) {
                    return value;
                }

                return value;
            } catch (error) {
                console.error('Error in companyOverrides processor:', error);
                return value;
            }
        },
    });

    instance = i18n.use(Backend).init({
        react: {
            useSuspense: false,
        },
        lng: window.localStorage.getItem('language') || 'en',
        fallbackLng: 'en',
        // load: "languageOnly",
        ns: ['common', 'assessment'],
        defaultNS: 'common',
        keySeparator: false,
        backend: {
            loadPath: `/static/locales/{{lng}}/{{ns}}.json`,
            commonStore,
        },
        debug: false,
        postProcess: ['companyOverrides'],
    });
    let lng = window.localStorage.getItem('language') || 'en';
    setMomentLocale(lng);
    return instance;
}

i18n.on('languageChanged', function (lng) {
    setMomentLocale(lng);
});

export default { init };
